// this should be the fn that returns fn
import initApiDietPaymentProcessor from "../../../../lib/common/js/apiDietPaymentProcessor"

const paymentBaseParams = {
  apiUrl: new URL("https://api.healthgenom.com"),
  paymodes: {
    paypal_recurring: 3,
    primer: 15,
  },
}

const paymentBaseParamsStaging = {
  apiUrl: new URL("https://api-staging.certifiedfasting.com"),
  paymodes: {
    paypal_recurring: 3,
    primer: 15,
  },
}

const apiDietPaymentProcessor = initApiDietPaymentProcessor(paymentBaseParams)

export default apiDietPaymentProcessor
